import {WatchListService} from "./WatchListService";
import {WatchListViewModelFactory} from "./WatchListViewModelFactory";

export default function() {
    return angular.module("tfApp.watchlist.services", [])
                  .service(WatchListService.id, WatchListService)
                  .service(WatchListViewModelFactory.id, WatchListViewModelFactory)
                  .name;
}
